import ApiBase from 'Services/Api/ApiBase';

class Me extends ApiBase {
    route = '/human-resources/me';
};

export default new Me();